import axios from 'axios'
import store from '../store';

const profile = {
  instance_id: "",
  init () {
    this.instance_id = store.getters['customer/instance_id'];
    if (store.getters['profile/profile_id'] == null) this.CreateProfileAnonymous(this.instance_id,  "");
    else this.ValidateProfile();
  },
  ValidateProfile() {
      axios({
          method: "get",
          url: `${process.env.VUE_APP_API}/profiles/status.json`,
          headers: {
              profileid: store.getters['profile/profile_id'],
              token: store.getters['profile/profile_token']
          },
          data: {}
      }).then(
          response => {
              response;
          },
          error => {
              error;
              this.CreateProfileAnonymous(this.instance_id,  "");
          }
      );
  },
  CreateProfileAnonymous (domain, name) {
      axios({
        method: "post",
        url: `${process.env.VUE_APP_API}/profiles/anonymous.json`,
        data: { profile: { domain: domain, name: name } }
      }).then(response => {
          store.commit("profile/SetProfile",response.data,{ root: true }) },
          () => { setTimeout( () => this.CreateProfileAnonymous(this.instance_id,  ""), 15000)
        }
      );
  },
  saveProfile() {
      axios({
          method: "put",
          url: `${process.env.VUE_APP_API}/profiles/account/${store.getters['profile/profile_id']}.json`,
          headers: {
              profileid: store.getters['profile/profile_id'],
              token: store.getters['profile/profile_token']
          },
          data: { profile:  store.getters['profile/profile'] }
      }).then(
          response => {
              response
          },
          error => {
              error
          }
      );
  },
  loginSmartLink(profile_id,token){
      return axios({
      method: "get",
      url: `${process.env.VUE_APP_API}/profiles/login_smart_link/${profile_id}.json?token=${token}`
      });
  },
  GetProfile() {
      return axios({
          method: "get",
          url: `${process.env.VUE_APP_API}/profiles/account.json`,
          headers: {
              profileid: store.state.profile.profile.id,
              token: store.state.profile.profile.token
          },
          data: {}
      })
  }

}

export {
  profile
}
